'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var component$5 = require('./component-54cd53d2.js');
var component$e = require('./component-294e2694.js');
var component$G = require('./component-c5b39525.js');

var UpcomingBookingContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  height: 142px;\n  width: 293px;\n  box-shadow: 0 2px 10px rgba(54, 54, 54, 0.2);\n  border-radius: 4px;\n  padding: 12px 18px 18px 18px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  cursor: pointer;\n"], ["\n  height: 142px;\n  width: 293px;\n  box-shadow: 0 2px 10px rgba(54, 54, 54, 0.2);\n  border-radius: 4px;\n  padding: 12px 18px 18px 18px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  cursor: pointer;\n"])));
var Title = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  font: 500 18px/24px ", ";\n  color: ", ";\n  -webkit-line-clamp: 1;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  font: 500 18px/24px ", ";\n  color: ", ";\n  -webkit-line-clamp: 1;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var StyledIconBlock = styled__default(component$e.IconBlock)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  padding-bottom: 5px;\n  .icon-block-title {\n    padding-bottom: 3px;\n    font-weight: 700;\n  }\n\n  .icon-block-subtitle {\n    padding-bottom: 3px;\n    -webkit-line-clamp: 1;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"], ["\n  padding-bottom: 5px;\n  .icon-block-title {\n    padding-bottom: 3px;\n    font-weight: 700;\n  }\n\n  .icon-block-subtitle {\n    padding-bottom: 3px;\n    -webkit-line-clamp: 1;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n"])));
var StyledStatusPill = styled__default(component$5.StatusPill)(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  margin-left: 24px;\n  .status-pill {\n    font-style: italic;\n  }\n"], ["\n  margin-left: 24px;\n  .status-pill {\n    font-style: italic;\n  }\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

var UpcomingBooking = function (_a) {
    var id = _a.id, title = _a.title, date = _a.date, time = _a.time, linkRef = _a.linkRef, linkText = _a.linkText, withStatus = _a.withStatus, status = _a.status, statusColor = _a.statusColor, onClick = _a.onClick, dataCy = _a.dataCy, dataTestId = _a.dataTestId, className = _a.className, isCheckInAllowed = _a.isCheckInAllowed, isCheckedIn = _a.isCheckedIn, checkInText = _a.checkInText, transactionId = _a.transactionId, onCheckIn = _a.onCheckIn;
    var handleCheckIn = React.useCallback(function (event) {
        event.stopPropagation();
        // eslint-disable-next-line no-unused-expressions
        onCheckIn === null || onCheckIn === void 0 ? void 0 : onCheckIn(transactionId);
    }, [transactionId, onCheckIn]);
    var handleUpcomingBookingClick = React.useCallback(function () {
        onClick(id);
    }, [id, onClick]);
    return (React__default.createElement(UpcomingBookingContainer
    // eslint-disable-next-line react/jsx-no-bind
    , { 
        // eslint-disable-next-line react/jsx-no-bind
        onClick: handleUpcomingBookingClick, "data-testid": dataTestId, "data-cy": dataCy, className: className },
        React__default.createElement(Title, { className: "upcoming-booking-title" }, title),
        React__default.createElement("div", null,
            React__default.createElement(StyledIconBlock, { isDisabled: true, title: date, icon: "calendar-alt", iconType: "fal", subtitle: time, linkRef: (!withStatus && linkRef), linkText: (!withStatus && linkText) }),
            withStatus && React__default.createElement(StyledStatusPill, { status: status, color: statusColor }),
            isCheckInAllowed && (React__default.createElement(component$G.CheckInBlock, { isCheckedIn: isCheckedIn, checkInText: checkInText, 
                // eslint-disable-next-line react/jsx-no-bind
                onClick: handleCheckIn })))));
};
UpcomingBooking.defaultProps = {
    linkRef: null,
    linkText: null,
    status: null,
    statusColor: null,
    withStatus: false,
    dataCy: 'upcoming-booking',
    dataTestId: 'upcoming-booking',
    className: 'upcoming-booking',
    isCheckInAllowed: false,
    isCheckedIn: false,
    checkInText: null,
    transactionId: null,
    onCheckIn: null,
};

exports.UpcomingBooking = UpcomingBooking;
